module.exports = __webpack_public_path__ + "img/百花呈瑞.49895dae.png";